import { RiskReportInstanceState } from 'app/area/case-report/risk-listing/types-store';
import { ApplicationState } from 'app/types-store';

export const selectRiskReportInstanceState = (riskReportInstanceKey: string) => (state: ApplicationState): RiskReportInstanceState =>
  state?.riskReport?.instances?.[riskReportInstanceKey];

export const selectReportInstanceState = (instanceKey: string) => (state: ApplicationState) =>
  state?.favourite.instances?.[instanceKey];

export const selectRiskReportResults = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.riskReportResults;

export const selectFetching = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.fetching;

export const selectErrorsExecuteFailed = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.errorsExecuteFailed;

export const selectLayoutTypeAttributes = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)
    ?.riskReportResults?.layoutModel?.layoutTypeAttributes;

export const selectFetchingOptionsDrillDownTo = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.fetchingOptionsDrillDownTo;

  export const selecOptionsDrillDownTo = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.optionsDrillDownTo;

export const selectFetchingOptionsDrillDownLayoutTypesTo = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.fetchingLayoutTypesDrillDownTo;

export const selecOptionsDrillDownLayoutTypesTo = (riskReportInstanceKey: string) =>
  (state: ApplicationState) => selectRiskReportInstanceState(riskReportInstanceKey)(state)?.optionsLayoutTypesDrillDownTo;
